import moment, { Moment } from "moment";
import business from "moment-business";

/** True if Mon–Fri AND not a holiday */
export function isBusinessDay(m: Moment, holidays: string[] = []): boolean {
    const d = m.clone().startOf("day").format("YYYY-MM-DD");
    return business.isWeekDay(m) && !holidays.includes(d);
}

/** Add N business days, skipping weekends + holidays (mutates clone, returns clone) */
export function addBusinessDays(
    m: Moment,
    n: number,
    holidays: string[] = [],
): Moment {
    const cur = m.clone();
    let remaining = n;
    while (remaining !== 0) {
        const step = remaining > 0 ? 1 : -1;
        cur.add(step, "day");
        if (isBusinessDay(cur, holidays)) remaining -= step;
    }
    return cur;
}

/** Business-day diff excluding weekends + holidays (positive if end>start) */
export function businessDiff(
    start: Moment,
    end: Moment,
    holidays: string[] = [],
): number {
    // Base weekday count (Mon–Fri) from moment-business:
    const base = business.weekDays(start, end);

    // Subtract holidays that fall on weekdays within [min,max)
    const min = moment.min(start, end).clone().startOf("day");
    const max = moment.max(start, end).clone().startOf("day");

    const holidayCount = holidays.filter((iso) => {
        const h = moment(iso, "YYYY-MM-DD");
        return h.isSameOrAfter(min) && h.isBefore(max) && business.isWeekDay(h);
    }).length;

    return start.isBefore(end) ? base - holidayCount : -(base - holidayCount);
}

/** Next business day (>= tomorrow) */
export function nextBusinessDay(from: Moment, holidays: string[] = []): Moment {
    let d = from.clone();
    do {
        d.add(1, "day");
    } while (!isBusinessDay(d, holidays));
    return d;
}

/** Previous business day (<= yesterday) */
export function prevBusinessDay(from: Moment, holidays: string[] = []): Moment {
    let d = from.clone();
    do {
        d.subtract(1, "day");
    } while (!isBusinessDay(d, holidays));
    return d;
}
